import { css } from 'lit';

export default css`
  /* Spacing */
  --spacing-xs: 0.25rem;            /* Extra small spacing */
  --spacing-sm: 0.5rem;             /* Small spacing */
  --spacing-md: 1rem;               /* Medium spacing */
  --spacing-lg: 1.5rem;             /* Large spacing */
  --spacing-xl: 2rem;               /* Extra large spacing */
`;
